import { Component, HostListener, OnInit } from '@angular/core';
import { GovernoratesService } from '../../../../services/governorates.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-deliveryareamobile',
  templateUrl: './deliveryareamobile.component.html',
  styleUrl: './deliveryareamobile.component.scss'
})
export class DeliveryareamobileComponent implements OnInit {

  allData: any[] = [];
  visibleData: any[] = [];

  governorates: any[] = [];

  contentReady: boolean = true;
  noData: boolean = false;
  submitting: boolean = false;
  loadingMore: boolean = false;

  isAr: boolean = false;

  priceForm!: FormGroup;

  pageSize: number = 10;
  currentLimit: number = 10;

  constructor(
    private governoratesService: GovernoratesService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.isAr = localStorage.getItem('language') === 'ar';

    this.initForm();
    this.loadGovernorates();
    this.loadGovernoratePrices();
  }

  initForm(): void {
    this.priceForm = this.fb.group({
      governorate_id: ['', Validators.required],
      price: ['', [Validators.required, Validators.min(0)]],
    });
  }

  loadGovernorates(): void {
    this.governoratesService.getAllGovernorates().subscribe({
      next: (data) => {
        this.governorates = data || [];
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  loadGovernoratePrices(): void {
    this.contentReady = true;
    this.noData = false;

    this.governoratesService.getAllGovernoratePrices().subscribe({
      next: (data) => {
        this.allData = data || [];

        this.currentLimit = this.pageSize;
        this.visibleData = this.allData.slice(0, this.currentLimit);

        this.noData = this.allData.length === 0;
        this.contentReady = false;
      },
      error: (err) => {
        console.error(err);
        this.contentReady = false;
        this.noData = true;
      }
    });
  }

  addItem(): void {
    if (this.priceForm.invalid || this.submitting) return;

    this.submitting = true;

    this.governoratesService.createGovernoratePrice(this.priceForm.value).subscribe({
      next: () => {
        this.submitting = false;

        this.priceForm.reset({
          governorate_id: '',
          price: ''
        });

        this.loadGovernoratePrices();

        Swal.fire(
          this.isAr ? 'تمت الإضافة' : 'Added successfully',
          '',
          'success'
        );
      },
      error: (err) => {
        console.error(err);
        this.submitting = false;

        Swal.fire(
          this.isAr ? 'حدث خطأ' : 'Something went wrong',
          '',
          'error'
        );
      }
    });
  }

  loadMore(): void {
    if (this.loadingMore) return;
    if (this.visibleData.length >= this.allData.length) return;

    this.loadingMore = true;

    setTimeout(() => {
      this.currentLimit += this.pageSize;
      this.visibleData = this.allData.slice(0, this.currentLimit);
      this.loadingMore = false;
    }, 250);
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    const bottomReached = scrollPosition + windowHeight >= pageHeight - 120;

    if (bottomReached) {
      this.loadMore();
    }
  }

  trackById(index: number, item: any): any {
    return item?.id || index;
  }
}